import '../lib/globals/babel'
import '../lib/chunk_load_handler'

import loadPolyfills from '../lib/polyfills'
import { setupApiProxy } from './util/setupApiProxy'
import '../lib/init.scss'

const APP_NAME = 'Poll Everywhere Webex'

async function bootApp () {
  setupApiProxy()

  const startAppLoader = (await import(/* webpackChunkName: "start-app" */ './util/startApp'))

  const opts = {
    role: 'webex',
    theme: 'light',
    appName: APP_NAME
  }

  startAppLoader.startApp(opts)
}

loadPolyfills().then(async () => {
  if (navigator.onLine) {
    bootApp()
  } else {
    const offlineMessage = (await import(/* webpackChunkName: 'offline-message' */ './util/offlineMessage')).offlineMessage
    offlineMessage(APP_NAME)
  }
})
